import useGoalFAQs from '../goal/useGoalFAQs';
import useGoalInfo from '../goal/useGoalInfo';
import useGTPStaticData from '../gtp/useGTPStaticData';
import useHomeFeed from './useHomeFeed';

const useFullBrowseInfo = ({ goalUID, isGTP, fallbackData = {} }) => {
  const { key: goalInfoSWRKey, goalInfo } = useGoalInfo(goalUID, {
    fallbackData: fallbackData.goalInfo
  });

  const { key: faqSWRKey, faqs } = useGoalFAQs({
    fallbackData: fallbackData.faqs
  });

  const { key: gtpStaticDataSWRKey, gtpStaticContent } = useGTPStaticData(
    isGTP ? goalUID : null,
    { fallbackData: fallbackData.gtpStaticContent }
  );

  const { key: homeFeedRowSWRKey, homeFeed } = useHomeFeed(goalUID, {
    fallbackData: fallbackData.homeFeed
  });

  return {
    // SWR Keys for caching
    keys: {
      goalInfoSWRKey,
      faqSWRKey,
      gtpStaticDataSWRKey,
      homeFeedRowSWRKey
    },
    // Data for usage
    goalInfo,
    faqs,
    gtpStaticContent,
    homeFeed
  };
};

export default useFullBrowseInfo;
